import axios from 'axios';

export async function get(url, query, { token } = {}) {
  const res = await axios.get(`${localStorage.getItem('baseUrl')}${url}${query ? `?${query}` : ''}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return { data: res?.data?.data || res.data, count: res.headers?.count };
}

export async function post(url, body, { token = null, auth = null } = {}) {
  let options = {};
  if (token) {
    options = {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
  if (auth) {
    options = { ...options, auth };
  }
  const res = await axios.post(`${localStorage.getItem('baseUrl')}${url}`, body, options);
  return { data: res.data?.data || res.data };
}
